import {Blankslate} from '@primer/react/experimental'
import {RepoForkedIcon} from '@primer/octicons-react'
import {usePulsePeriod} from '../contexts/PulsePeriodContext'

interface BlankslateCommitsProps {
  owner: string | undefined
  repo: string | undefined
  forkPathUrl?: string
}

export function BlankslateCommits({owner, repo, forkPathUrl}: BlankslateCommitsProps) {
  const {selectedPeriod: period} = usePulsePeriod()
  return (
    <div>
      <Blankslate>
        <Blankslate.Heading>
          There hasn&apos;t been any commit activity on {owner}/{repo} over the last {period}
        </Blankslate.Heading>
        {forkPathUrl && (
          <>
            <Blankslate.Description>Want to help out?</Blankslate.Description>
            <Blankslate.PrimaryAction href={forkPathUrl}>
              <RepoForkedIcon /> Fork this repository
            </Blankslate.PrimaryAction>
          </>
        )}
      </Blankslate>
    </div>
  )
}

try{ BlankslateCommits.displayName ||= 'BlankslateCommits' } catch {}